module.exports = __webpack_public_path__ + "static/Prosty-CRM-online-dla-malych-firm-2e417c5f48723f6df1b72bc13d72baa1.jpg";